<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
    name: "BaseModal",
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        }
    },
    computed: {
        visible() {
            return this.value;
        }
    },
    methods: {
        close() {
            this.$emit('update', false);
        }
    }
})
</script>

<template>
    <transition name="fade">
        <div v-if="visible" class="modal-overlay" @click.self="close">
            <div class="base-modal">
                <div class="close" @click="close">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<style scoped lang="scss">
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;

    .base-modal {
        /* Frame 1000005968 */

        /* Auto layout */
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 56px 40px;
        gap: 40px;
        isolation: isolate;

        position: absolute;
        /*width: 898px;*/
        width: 60%;
        height: 377px;
        /*left: calc(50% - 898px / 2);*/
        left: calc(50% - 60% / 2);
        top: calc(50% - 377px / 2 + 0.5px);

        background: #FFFFFF;
        border-radius: 16px;

        .close {
          /* Frame */
          cursor: pointer;
          position: absolute;
          width: 24px;
          height: 24px;
          top: 16px;
          right: 16px;

          /* Inside auto layout */
          flex: none;
          order: 2;
          flex-grow: 0;
          z-index: 2;
        }
    }
}

@media (max-width: 768px) {
    .modal-overlay {
        align-items: stretch;
        padding: 0;
        overflow: hidden;
        z-index: 9999;

        .base-modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            max-height: none;
            border-radius: 0;
            padding: 16px;
            gap: 16px;
            box-sizing: border-box;
            .close {
                top: 16px;
                right: 16px;
            }
        }
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease;
}
.fade-enter-from, .fade-leave-to {
    opacity: 0;
}
</style>
